import type { WelcomeStep } from "../types/WelcomeFlowTypes";

// The tour's centered intro; anchored steps load live from the Library flow guide.
export const libraryNewUserSteps: WelcomeStep[] = [{ key: "library-welcome", label: "Welcome", centered: true }];
